import React from "react";
import PropTypes from "prop-types";
import { Badge, Button, Card, CardHeader, EmptyState, Plus, Table, Users01 } from "@opendate-app/setlist";
import { useStaffingPermissionsContext } from "./StaffingPermissionsContext";
import { describeScope } from "./staffingPermissionLabels";

const PersonOverridesCard = ({ onEdit }) => {
  const { permissions, members, grants, departments, positions } = useStaffingPermissionsContext();
  const personGrants = grants.filter((grant) => grant.grantee_type === "TeamMembership");
  const editable = (grant) =>
    Boolean(members.find((member) => member.value === grant.grantee_id)?.editable) &&
    Boolean(permissions.find((permission) => permission.key === grant.permission)?.editable);

  const columns = [
    {
      key: "person",
      header: "Person",
      primary: true,
      render: (grant) => members.find((member) => member.value === grant.grantee_id)?.label || "Former member",
    },
    { key: "permission", header: "Permission", render: (grant) => permissions.find((permission) => permission.key === grant.permission)?.label },
    {
      key: "effect",
      header: "Access",
      render: (grant) => (
        <Badge size="sm" color={grant.effect === "allow" ? "success" : "error"}>
          {grant.effect === "allow" ? "Allow" : "Deny"}
        </Badge>
      ),
    },
    { key: "scope", header: "Where", render: (grant) => describeScope(grant, departments, positions) },
    {
      key: "actions",
      header: "",
      align: "right",
      render: (grant) =>
        editable(grant) && (
          <Button variant="tertiary" size="sm" onClick={() => onEdit({ grantee_type: "TeamMembership", grantee_id: grant.grantee_id, permission: grant.permission, grant })}>
            Edit
          </Button>
        ),
    },
  ];

  return (
    <Card
      padding="md"
      style={{ marginBottom: 20 }}
      header={
        <CardHeader
          title="Person overrides"
          supportingText="Give or take away a permission for one person. A person override beats their role."
          actions={
            <Button variant="primary" size="sm" icon={Plus} onClick={() => onEdit({ grantee_type: "TeamMembership" })}>
              Add override
            </Button>
          }
        />
      }
    >
      {personGrants.length === 0 ? (
        <EmptyState icon={Users01} title="No person overrides" description="Everyone follows their role's permissions." />
      ) : (
        <Table columns={columns} data={personGrants} getRowKey={(grant) => grant.id} />
      )}
    </Card>
  );
};

PersonOverridesCard.propTypes = {
  onEdit: PropTypes.func.isRequired,
};

export default PersonOverridesCard;
